/**
 * Checks if at least 50% of the HTMLElement are currently in view
 * @param element The target HTMLElement to assess visibility of
 */
const atLeastHalfOfElementInViewport = (element: Element): boolean => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= ((window.innerHeight || document.documentElement.clientHeight) + (rect.height / 2)) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export { atLeastHalfOfElementInViewport };
